import { Spinner } from 'flowbite-react';
import React from 'react';
import { HiOutlinePlus } from 'react-icons/hi';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Container from 'src/components/shared/Container';
import { DRIVE_FONT_STYLE, MobileActionBar, MobileHeader, PrimaryButton, useDriveFont, BackLink } from 'src/components/placementDrives/shared';
import { useGetMyDriveStatus } from 'src/hooks/drives.hooks';
import { ApplicationList } from './PlacementDriveStatusPage';

// Companies the candidate applied to for a drive, with their status, and a way to apply to more.
const PlacementDriveCompaniesPage = () => {
	useDriveFont();
	const { driveId } = useParams();
	const navigate = useNavigate();
	const { data, isLoading } = useGetMyDriveStatus(driveId);

	if (isLoading) {
		return (
			<div className="flex justify-center py-24">
				<Spinner size="xl" />
			</div>
		);
	}
	if (!data?.drive) return <div className="py-24 text-center text-[#555770]">Drive not found.</div>;
	if (data.stage === 'not_applied') return <Navigate to={`/placement-drives/${driveId}`} replace />;

	const { drive } = data;
	const goBack = () => navigate(`/placement-drives/${drive._id}/status`);
	const goToApply = () => navigate(`/placement-drives/${drive._id}/apply`);

	return (
		<Container className="dp-fade w-[92%] max-w-[860px] pt-0 pb-32 lg:pt-8 lg:pb-16" style={DRIVE_FONT_STYLE}>
			<MobileHeader title={drive.name} onBack={goBack} />
			<BackLink className="hidden lg:inline-flex" onClick={goBack}>Back to entry pass</BackLink>

			<div className="mt-2 flex items-end justify-between gap-4">
				<div>
					<h1 className="text-[30px] leading-[34px] font-[800] tracking-[-0.03em] text-[#111E2C] dark:text-white lg:text-[36px] lg:leading-[40px]">
						My companies
					</h1>
					<p className="mt-2 text-[15px] text-[#555770]">
						{data.applications.length} {data.applications.length === 1 ? 'company' : 'companies'} you applied to for {drive.name}
					</p>
				</div>
				{data.canAddMorePositions ? (
					<button
						onClick={goToApply}
						className="hidden shrink-0 items-center gap-2 rounded-[12px] bg-gradient-to-b from-[#5B4FF0] to-[#3027D8] px-5 py-3 text-[14px] font-[600] text-white shadow-[0_6px_16px_rgba(79,70,229,0.3)] lg:inline-flex"
					>
						<HiOutlinePlus className="h-4 w-4" />
						Add more companies
					</button>
				) : null}
			</div>

			<div className="dp-rise mt-6" style={{ animationDelay: '0.1s' }}>
				<ApplicationList applications={data.applications} />
			</div>

			{data.canAddMorePositions ? (
				<p className="mt-4 rounded-[16px] bg-[#F6F6FA] p-4 text-[14px] leading-[22px] text-[#555770] dark:bg-[#1F2937]">
					Your seat is already confirmed. You can apply to more companies, and their status shows on each row.
				</p>
			) : null}

			{data.canAddMorePositions ? (
				<MobileActionBar>
					<PrimaryButton className="w-full !py-4 !text-[17px]" onClick={goToApply}>
						Add more companies
					</PrimaryButton>
				</MobileActionBar>
			) : null}
		</Container>
	);
};

export default PlacementDriveCompaniesPage;
